// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-52d955bc] .mx-datepicker {\n  margin-top: 5px;\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
